export default __webpack_public_path__ + "static/media/inside-logo.93536f5f.svg";